import { render, staticRenderFns } from "./onClients.vue?vue&type=template&id=683f8fc3&"
import script from "./onClients.vue?vue&type=script&lang=js&"
export * from "./onClients.vue?vue&type=script&lang=js&"
import style0 from "./onClients.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports